import React from "react";
import { useCallback } from "react";
import { createExamFormValidator } from "../../validators";
import { Field, Form } from "react-final-form";
import Paper from "@material-ui/core/Paper";
import { Theme } from "@material-ui/core/styles";
import Button from "../../../../components/Button";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import BootstrapInput from "../../../../components/BootstrapInput";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { AdapterLink } from "../../../../components/Adopter";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import { Routes } from "../../../../constants/routes";
import { mutateErrors } from "../../../../utils";
import { FORM_ERROR } from "final-form";
import useExamQueries from "../../hooks/useExamQueries";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      padding: 15,
    },
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
  root: {
    maxWidth: 300,
    margin: "0 auto",
  },
}));

export default function CreatePage() {
  const classes = useStyles();
  const { fetchCreate } = useExamQueries();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const create = useCallback(
    async (data) => {
      try {
        await fetchCreate(data);
        history.push(`/0/${Routes.EXAMS}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchCreate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container maxWidth="md" className={classes.container}>
      <Breadcrumbs>
        <AdapterLink to="/0">Home</AdapterLink>
        <AdapterLink to="/0/exam">Exams</AdapterLink>
        <Typography color="textPrimary">Create</Typography>
      </Breadcrumbs>
      <Paper>
        <Form onSubmit={create} validate={createExamFormValidator}>
          {({ submitting, submitError, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {submitError && (
                <Typography color="error" align="center">
                  {submitError}
                </Typography>
              )}
              {submitting && <Loading />}
              <Typography component="div" className={classes.root}>
                <Typography component="div" className={classes.formControl}>
                  <Field
                    fullWidth
                    type="text"
                    name="name"
                    label="Name"
                    placeholder="Name"
                    component={BootstrapInput}
                  />
                </Typography>
                <Typography
                  align="center"
                  component="div"
                  className={classes.formControl}
                >
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    disabled={submitting}
                  >
                    Save
                  </Button>
                </Typography>
              </Typography>
            </form>
          )}
        </Form>
      </Paper>
    </Container>
  );
}
